import React from "react";
import clsx from "clsx";
import Exterior360 from "./Exterior360";
import styles from "../SpinContainer.module.scss";
import { useCarConfigSelector } from "../../../../../redux/store";
import { SpinnerType } from "../../../../../redux/slices/CarConfigSpinNavigationSlice";

export const EXTERIOR_SPIN_ID = "or-exterior-spin-wrapper";

const Exterior360Wrapper = (): JSX.Element => {
    const exteriorSpinIsActive = useCarConfigSelector(
        (state) => state.carConfigSpinNavigation.activeSpin === SpinnerType.Car,
    );
    return (
        <figure
            className={clsx(exteriorSpinIsActive ? styles.active : styles.inactive, styles["spin-image-wrapper"])}
            id={EXTERIOR_SPIN_ID}
        >
            <div>
                <Exterior360
                    index={3}
                    imageOptions={{
                        bgColour: "FFFFFF",
                        width: 1000,
                        height: 533,
                        padding: 0,
                        srcSet: [
                            { width: 300, height: 171 },
                            { width: 600, height: 342 },
                            { width: 1170, height: 666 },
                            { width: 1624, height: 924 },
                            { width: 1850, height: 1053 },
                            { width: 2048, height: 1165 },
                        ],
                    }}
                />
            </div>
        </figure>
    );
};

export default Exterior360Wrapper;
